import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Recap from './Recap';
import ResultItems from './ResultItems';
import { LoadingState, ResultsHeader } from './partials';
import ErrorState from '@client/components/shared/ErrorState';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import RiskSymbolsLegends from '@client/components/ui/RiskSymbolsLegends';
import ProductLegends from '@client/components/ui/productLegends';
import thumbnail from '../../../../../../img/thumbnail.svg';
import table from '../../../../../../img/table.svg';
import externalLinkGreen from '../../../../../../img/external-link-green.svg';


const Result = ({
  filters,
  data,
  isLoading,
  error,
  getFilterLabel,
  onResetFilters,
  onRemoveFilter,
  onPageChange,
  onSortChange,
  currentSorting,
  onShare,
  onFiltersFromURL,
}) => {
  const { t } = useTranslation();
  const [view, setView] = useState('card');

  const handleViewChange = (view) => {
    setView(view);
  };

  if (isLoading) return <LoadingState />;
  if (error) return <ErrorState error={error} />;


  /**
 * Legend section component
 * @param {Object} props - Component props
 * @param {Function} props.t - Translation function
 * @returns {JSX.Element} Legend section
 */
  const LegendSection = ({ t }) => (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <div className="flex rounded-2xl bg-gray-50 border border-gray-200 px-6 py-2 justify-start">
          <RiskSymbolsLegends title={t('treatment|Risk symbols :')} />
        </div>

        <div className="flex rounded-2xl bg-gray-50 border border-gray-200 px-6 py-2 justify-start">
          <ProductLegends />
        </div>
      </div>
    </>
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1],
      }}
    >
      <ResultsHeader data={data} onShare={onShare} />
      <Recap
        filters={filters}
        data={data}
        onResetFilters={onResetFilters}
        onRemoveFilter={onRemoveFilter}
        getFilterLabel={getFilterLabel}
        onFiltersFromURL={onFiltersFromURL}
      />

      <div className="flex justify-between mb-10 flex-wrap gap-4">
        <div className="flex gap-2 flex-wrap w-full sm:w-auto">
          <Button type={`${view === 'table' ? 'primary' : 'default'}`} size="large" className='w-full sm:w-auto' onClick={() => handleViewChange('table')}><img src={table} alt="table" />{t('common|Affichage tableau')}</Button>
          <Button type={`${view === 'card' ? 'primary' : 'default'}`} size="large" className='w-full sm:w-auto' onClick={() => handleViewChange('card')}><img src={thumbnail} alt="thumbnail" />{t('common|Affichage vignettes')}</Button>
        </div>

        <Button type="default" size="large" onClick={() => { }}><img src={externalLinkGreen} alt="external link" />{t('common|Production intégrée')}</Button>

        <div className="w-full flex gap-1 items-center sm:w-[400px]">
          <label htmlFor="order" className='whitespace-nowrap'> {t('common|Tri par :')} </label>
          <select name="order" id="order" className='form-input'>
            <option value="">option 1</option>
            <option value="">option 2</option>
            <option value="">option 3</option>
          </select>
        </div>
      </div>

      <LegendSection t={t} />

      <ResultItems
        data={data}
        filters={filters}
        onPageChange={onPageChange}
        onSortChange={onSortChange}
        currentSorting={currentSorting}
        view={view}
      />
    </motion.div>
  );
};

export default React.memo(Result);